export default {
  "info": (ctx) => {const { normalize: _normalize } = ctx;return _normalize(["用户详情"])}
}